import api from './api';

class WeeklyOffService {
  /**
   * Create weekly off
   * @param {Object} weeklyOffData - Weekly off data
   * @returns {Promise<Object>} API response
   */
  static async createWeeklyOff(weeklyOffData) {
    try {
      const response = await api.post('/weekly-off/create', weeklyOffData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get all weekly offs
   * @returns {Promise<Object>} API response
   */
  static async getAllWeeklyOffs() {
    try {
      const response = await api.get('/weekly-off/all');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Update weekly off
   * @param {string} weeklyOffId - Weekly off ID
   * @param {Object} updateData - Update data
   * @returns {Promise<Object>} API response
   */
  static async updateWeeklyOff(weeklyOffId, updateData) {
    try {
      const response = await api.patch(`/weekly-off/update/${weeklyOffId}`, updateData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Delete weekly off
   * @param {string} weeklyOffId - Weekly off ID
   * @returns {Promise<Object>} API response
   */
  static async deleteWeeklyOff(weeklyOffId) {
    try {
      const response = await api.delete(`/weekly-off/delete/${weeklyOffId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Set weekly off configuration
   * @param {Array} dayNumbers - Array of day numbers (0-6)
   * @returns {Promise<Object>} API response
   */
  static async setWeeklyOffConfiguration(dayNumbers) {
    try {
      const response = await api.post('/weekly-off/set-configuration', { dayNumbers });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Check if date is weekly off
   * @param {string} date - Date to check (YYYY-MM-DD)
   * @returns {Promise<Object>} API response
   */
  static async checkWeeklyOff(date) {
    try {
      const response = await api.get(`/weekly-off/check/${date}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get weekly off days
   * @returns {Promise<Object>} API response
   */
  static async getWeeklyOffDays() {
    try {
      const response = await api.get('/weekly-off/days');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default WeeklyOffService;